import type { IconSvgObject } from './types';

const JapaneseYenIcon: IconSvgObject = [
  ["path", { d: "M5.00066 3C5.46732 4.73148 7.52066 8.66667 12.0007 10.5556M12.0007 10.5556C16.4807 8.66667 18.534 4.73148 19.0007 3M12.0007 10.5556V21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M6.16472 13H17.8314", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M6.16472 17H17.8314", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }]
];

export default JapaneseYenIcon;
